import React from 'react';
import { Table } from 'react-bootstrap';

function ProjectScopeSetting({
  scopes,
  platform, 
  costingTotals, 
  onCalculate, 
  computeTotals,
  readOnly
}) {
  const setProjectScope = (scopes) => {
    let scopesList = [];

    scopesList = scopes.length ? (
      scopes.filter(data => {
        if (data.platform_id === platform.id) {
          return data;
        }
        return false;
      }).map((scope, key) => {
        return (
          <tr key={key}>
            <td><b>Band {scope.band_group}</b></td>
            <td>
              <input type="number" 
                className="num-input" 
                disabled={readOnly ? true : false}
                id={scope.band_group} 
                defaultValue={scope.mandays > 0 ? scope.mandays : ""}
                name="mandays" 
                style={{"maxWidth": "100px"}} 
                onBlur={(e) => {
                  onCalculate(e, platform);
                }}/>
            </td>
            <td className="align-center">{scope.manhours}</td>
            <td className="align-center">{parseFloat(scope.percentage).toFixed(2) > 0 ? parseFloat(scope.percentage).toFixed(2) + "%" : ""}</td>
          </tr>
        )
      })
    ) : (
      <tr>
        <td colSpan={4}>Loading...</td>
      </tr>
    )
    computeTotals();
    return scopesList;
  }

  const displayTotals = () => {
    let totalMandays = 0;
    let totalManhours = 0;
    let totalPercentage = 0;

    costingTotals.length && costingTotals.filter(data => {
      if (data.platformId === platform.id) {
        return data;
      }
      return false;
    }).forEach(total => {
      totalMandays = total.totalMandays;
      totalManhours = total.totalManhours;
      totalPercentage = total.totalPercentage;
    })

    return (
      <tr>
        <td><b>Total</b></td>
        <td className="align-center">{totalMandays > 0 ? totalMandays.toFixed(2) : "-"}</td>
        <td className="align-center">{totalManhours > 0 ? totalManhours.toFixed(2) : "-"}</td>
        <td className="align-center">{totalPercentage > 0 ? totalPercentage.toFixed(2) + "%" : "-"}</td>
      </tr>
    )
  }

  return (
    <Table>
      <thead>
        <tr>
          <th className="align-center">Project Scope</th>
          <th className="align-center">Mandays</th>
          <th className="align-center">Manhours</th>
          <th className="align-center">Percentage</th>
        </tr>
      </thead>
      <tbody>
        { setProjectScope(scopes) }
        { displayTotals(costingTotals) }
      </tbody>
    </Table>
  )
}

export default ProjectScopeSetting
